import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity`
  width: 40px;
  height: 40px;
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 100;
  background-color: white;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  /* Removed padding to let flex center the fixed-size image properly */
  elevation: 5;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
`;
